var _mask, _path, _mask2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1010_10478",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03477 0H1.31055C1.0344 0 0.810547 0.223857 0.810547 0.5V19.5C0.810547 19.7761 1.03441 20 1.31055 20H10.1796C10.4557 20 10.6796 19.7761 10.6796 19.5V10.5C10.6796 10.2239 10.9035 10 11.1796 10H20.0487C20.3248 10 20.5487 9.77614 20.5487 9.5V0.5C20.5487 0.223858 20.3248 0 20.0487 0H10.6796H9.03477Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.31055 1.5H9.03477V-1.5H1.31055V1.5ZM2.31055 19.5V0.5H-0.689453V19.5H2.31055ZM10.1796 18.5H1.31055V21.5H10.1796V18.5ZM9.1796 10.5V19.5H12.1796V10.5H9.1796ZM20.0487 8.5H11.1796V11.5H20.0487V8.5ZM19.0487 0.5V9.5H22.0487V0.5H19.0487ZM10.6796 1.5H20.0487V-1.5H10.6796V1.5ZM9.03477 1.5H10.6796V-1.5H9.03477V1.5ZM22.0487 0.5C22.0487 -0.604568 21.1532 -1.5 20.0487 -1.5V1.5C19.4964 1.5 19.0487 1.05228 19.0487 0.5H22.0487ZM12.1796 10.5C12.1796 11.0523 11.7319 11.5 11.1796 11.5V8.5C10.075 8.5 9.1796 9.39543 9.1796 10.5H12.1796ZM10.1796 21.5C11.2842 21.5 12.1796 20.6046 12.1796 19.5H9.1796C9.1796 18.9477 9.62732 18.5 10.1796 18.5V21.5ZM-0.689453 19.5C-0.689453 20.6046 0.20598 21.5 1.31055 21.5V18.5C1.86283 18.5 2.31055 18.9477 2.31055 19.5H-0.689453ZM20.0487 11.5C21.1532 11.5 22.0487 10.6046 22.0487 9.5H19.0487C19.0487 8.94772 19.4964 8.5 20.0487 8.5V11.5ZM1.31055 -1.5C0.205979 -1.5 -0.689453 -0.604572 -0.689453 0.5H2.31055C2.31055 1.05229 1.86283 1.5 1.31055 1.5V-1.5Z",
    fill: "black",
    mask: "url(#path-1-inside-1_1010_10478)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_1010_10478",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.1465,
    y: 12.5,
    width: 7.40179,
    height: 7.5,
    rx: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.1465,
    y: 12.5,
    width: 7.40179,
    height: 7.5,
    rx: 0.5,
    stroke: "black",
    strokeWidth: 3,
    mask: "url(#path-3-inside-2_1010_10478)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.6715f57b0c0571ab6cc77869324c27f2.svg";
export { ForwardRef as ReactComponent };